import {changeEvent, dispatchCustomEvent} from "../../../../../../../webpack/modules/events";
import {isDesktop} from "../../../../../../../webpack/modules/devices";
import {updatePriceElements, updateSizesPrices} from "../../../../../../../webpack/modules-optimized/product-list";

changeEvent('#product-list-page .product-configuration-supportColor[data-option-type="selectable"] input[name="support-color"]', true, function(element) {
    let mainContainer = isDesktop() ? element.closest('.product').querySelector('.product-configuration-main') : document.querySelector('#product-list-page .offcanvas.product-configuration-main');
    let container = element.closest('.product-configuration');
    let previewElement = mainContainer.querySelector('.open-configuration .preview-option-supportColor');

    dispatchCustomEvent(
        'productSupportColorChanged',
        {
            'option': container,
            'previewElement': previewElement,
        }
    );
    container.querySelectorAll('.support-color.selected').forEach(option => option.classList.remove('selected'));
    element.nextElementSibling.classList.add('selected');
    mainContainer.querySelector('input[name="option-supportColor"]').value = element.value;
    updatePriceElements(container);
    updateSizesPrices(container);
    container.dataset.completed = 'true';
    dispatchCustomEvent('productListProductConfigurationChanged');
});